module.exports = __webpack_public_path__ + "static/media/Nunito-Bold.974bca2b.ttf";